import { Upload, message, UploadFile } from "antd";
import type { UploadRequestOption } from "rc-upload/lib/interface";
import { CameraOutlined } from "@ant-design/icons";
import AnimatedLogo from "./AnimatedLogo";
import { useState } from "react";

interface FileUploadProps {
  questionId: string;
  value?: string[];
  disabled?: boolean;
  onChange: (questionId: string, field: string, value: string[]) => void;
}

export default function FileUpload({ questionId, value, disabled, onChange }: FileUploadProps) {
  const [loading, setLoading] = useState(false);

  const fileList = (value ?? []).map((url, index) => ({
    uid: String(index),
    name: `foto${index + 1}.png`,
    status: "done" as const,
    url,
  }));

  const handleUpload = async (options: UploadRequestOption) => {
    const { file, onSuccess, onError } = options;
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file as File);

    try {
      const res = await fetch(
        "https://bpbp3krbb9.execute-api.eu-west-1.amazonaws.com/beats_runners/upload-photo",
        {
          method: "POST",
          body: formData,
        }
      );
      const result = await res.json();

      if (result.url) {
        onChange(questionId, "val_file", [...(value ?? []), result.url]);
        onSuccess?.(result, file as File);
      } else {
        message.error("Chyba: odpověď neobsahuje URL");
        onError?.(new Error("No URL in response"));
      }
    } catch (err) {
      console.error("❌ Upload error:", err);
      message.error("Chyba při nahrávání souboru");
      onError?.(err as Error);
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = (file: UploadFile) => {
    const updated = (value ?? []).filter((url) => url !== file.url);
    onChange(questionId, "val_file", updated);
  };

  return (
    <Upload
      name="file"
      accept="image/*"
      listType="picture-card"
      multiple
      disabled={disabled}
      fileList={fileList}
      showUploadList={{
        showRemoveIcon: !disabled,
        showPreviewIcon: false,
      }}
      customRequest={handleUpload}
      onRemove={handleRemove}
    >
      {loading ? (
        <div style={{ width: "100%", textAlign: "center" }}>
          <AnimatedLogo loading="spinner" withBackground={false} />
        </div>
      ) : (
        <div style={{ textAlign: "center" }}>
          <CameraOutlined style={{ fontSize: 32 }} />
          <div style={{ marginTop: 8 }}>Nahrát / Vyfotit</div>
        </div>
      )}
    </Upload>
  );
}
